import {Component} from '@angular/core';
import {
    AlertController, LoadingController, ModalController, NavController, NavParams, Platform,
    ToastController, ViewController
} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";
import {Storage} from "@ionic/storage";

@Component({
    selector: 'page-all-school-admisssions-report',
    templateUrl: 'all-school-admisssions-report.html',
})
export class AllSchoolAdmisssionsReportPage {

    School = 'GWW';
    SchoolData = {};
    Data: any;


    Total10Adm: any;
    TotalAdm: any;
    ContinueAdm: any;
    NewAdm: any;
    NotContinueAdm: any;
    OverAllReportAdm: any;

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public service: ServiceProvider,
                public platform: Platform,
                public loadingCtrl: LoadingController,
                public toastCtrl: ToastController,
                public storage: Storage,
                public viewCtrl: ViewController,
                public modalCtrl: ModalController,
                public alertCtrl: AlertController) {


        this.platform.ready().then(() => {

            this.SchoolData = {
                "All": 0,
                "GWW": 2,
                "GWE": 3,
                "GEIS": 1
            };

            this.loadDataCount(this.SchoolData[this.School]);

        });

    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad AllSchoolAdmisssionsReportPage');
    }

    active_tab(tab) {
        console.log(tab);
        this.School = tab;
        this.loadDataCount(this.SchoolData[this.School]);
    }

    loadDataCount(FSchoolId) {

        if (FSchoolId == 1) {
            this.GEIS_loadvalues();
        }
        else if (FSchoolId == 2) {
            this.GWW_loadvalues();
        }
        else if (FSchoolId == 3) {
            this.GWE_loadvalues();
        }

    }

    GWE_loadvalues() {

        this.TotalAdm = [];
        this.ContinueAdm = [];
        this.NewAdm = [];
        this.NotContinueAdm = [];
        this.OverAllReportAdm=[];

        const loader = this.loadingCtrl.create({
            content: "Please wait...",
            duration: 10000
        });
        loader.present();

        this.service.httpcall('app_web_service/get_GWE_total_admission_report?').subscribe(data => {

            this.TotalAdm = data;
            console.log('TotalAdm', this.TotalAdm);
        });
        this.service.httpcall('app_web_service/get_GWE_continue_admissions_report?').subscribe(data => {

            this.ContinueAdm = data;
            console.log('AdminReport', this.ContinueAdm);
        });
        this.service.httpcall('app_web_service/get_GWE_New_admissions_report?').subscribe(data => {

            this.NewAdm = data;
            console.log('NewAdm', this.NewAdm);
        });
        this.service.httpcall('app_web_service/get_GWE_left_admissions_report?').subscribe(data => {

            this.NotContinueAdm = data;
            console.log('NotContinueAdm', this.NotContinueAdm);
        });
        this.service.httpcall('app_web_service/get_overall_admissions_report_by_school?FSchoolId=' + this.SchoolData[this.School]).subscribe(data => {
            this.OverAllReportAdm = data;
            console.log('OverAllReportAdm', this.OverAllReportAdm);
        });

        loader.dismiss();
    }

    GWW_loadvalues() {

        this.TotalAdm = [];
        this.ContinueAdm = [];
        this.NewAdm = [];
        this.NotContinueAdm = [];
        this.OverAllReportAdm = [];

        const loader = this.loadingCtrl.create({
            content: "Please wait...",
            duration: 10000
        });
        loader.present();

        this.service.httpcall('app_web_service/get_GWW_total_admission_report?').subscribe(data => {

            this.TotalAdm = data;
            console.log('TotalAdm', this.TotalAdm);
        });
        this.service.httpcall('app_web_service/get_GWW_continue_admissions_report?').subscribe(data => {

            this.ContinueAdm = data;
            console.log('AdminReport', this.ContinueAdm);
        });
        this.service.httpcall('app_web_service/get_GWW_New_admissions_report?').subscribe(data => {

            this.NewAdm = data;
            console.log('NewAdm', this.NewAdm);
        });
        this.service.httpcall('app_web_service/get_GWW_left_admissions_report?').subscribe(data => {

            this.NotContinueAdm = data;
            console.log('NotContinueAdm', this.NotContinueAdm);
        });

        this.service.httpcall('app_web_service/get_overall_admissions_report_by_school?FSchoolId=' + this.SchoolData[this.School]).subscribe(data => {
            this.OverAllReportAdm = data;
            console.log('OverAllReportAdm', this.OverAllReportAdm);
        });
        loader.dismiss();

    }

    GEIS_loadvalues() {

        this.Total10Adm = [];
        this.TotalAdm = [];
        this.ContinueAdm = [];
        this.NewAdm = [];
        this.NotContinueAdm = [];
        this.OverAllReportAdm = [];

        const loader = this.loadingCtrl.create({
            content: "Please wait...",
            duration: 10000
        });
        loader.present();

        this.service.httpcall('app_web_service/get_10th_stdwise_batchs_of_geis?').subscribe(data => {

            this.Total10Adm = data;
            console.log('Total10Adm', this.Total10Adm);
        });

        this.service.httpcall('app_web_service/get_total_admission_report?').subscribe(data => {

            this.TotalAdm = data;
            console.log('TotalAdm', this.TotalAdm);
        });

        this.service.httpcall('app_web_service/get_continue_admissions_report?').subscribe(data => {

            this.ContinueAdm = data;
            console.log('AdminReport', this.ContinueAdm);
        });
        this.service.httpcall('app_web_service/get_New_admissions_report?').subscribe(data => {

            this.NewAdm = data;
            console.log('NewAdm', this.NewAdm);
        });
        this.service.httpcall('app_web_service/get_left_admissions_report?').subscribe(data => {

            this.NotContinueAdm = data;
            console.log('NotContinueAdm', this.NotContinueAdm);
        });

        this.service.httpcall('app_web_service/get_overall_admissions_report_by_school?FSchoolId=' + this.SchoolData[this.School]).subscribe(data => {
            this.OverAllReportAdm = data;
            console.log('OverAllReportAdm', this.OverAllReportAdm);
        });

        loader.dismiss();

    }

    doRefresh(refresher) {
        console.log('Begin async operation', refresher);

        this.loadDataCount(this.SchoolData[this.School]);

        setTimeout(() => {
            console.log('Async operation has ended');

            refresher.complete();
        }, 2000);
    }

    backBTN() {
        this.viewCtrl.dismiss();
    }

}



// WEBPACK FOOTER //
// ./src/pages/all-school-admisssions-report/all-school-admisssions-report.ts